export interface AppConfig {
  readonly auth: {
    isWalletAllowed: boolean
    isSignUpByEmailAllowed: boolean
    isDiscordAllowed: boolean
    isAuthRequired: boolean
    isReferralCodeFlowAllowed: boolean
  }
  readonly tokenMintAllowed: boolean
  readonly isMainNetFeature: boolean
  /** Bullseye leaderboard block (DEV-147): boards, realtime, history, the rank row. */
  readonly bullsEyeLeaderboard: boolean
  /**
   * Off-chain launch: every game screen runs its demo (off-chain) mode for guests
   * and signed-in users alike, and the on-chain screens (Meme Wars, Setups,
   * 1vs1, the on-chain Bull's Eye and Up/Down pool) are not rendered.
   */
  readonly offchainOnly: boolean
  readonly mobile: {
    upDown: boolean
    oneVsOne: boolean
    bullsEye: boolean
    setups: boolean
    rewards: boolean
  }
}

export enum Stand {
  beta = 'beta',
  dev = 'dev',
  prod = 'prod',
  mainnet = 'mainnet'
}
